import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const CancelAndReturnsModalContent = ()=>{
    const { getFormattedLabel , getLabel , hasLabel  } = useIntl();
    const phone = getLabel('account.cancelAndReturns.phone', {
        hideLabelKey: true
    });
    const email = getLabel('account.cancelAndReturns.email', {
        hideLabelKey: true
    });
    const customerServiceKey = 'account.cancelAndReturns.customerService';
    const labelValue = getLabel(customerServiceKey);
    var ref;
    // we want to avoid making multiple labels when we're adding a url, we use one label and retrieve the text and url from it so we can pass it to the Link and Text component
    const [, text, url] = (ref = /\[(.*)\]\((.*)\)/.exec(labelValue)) !== null && ref !== void 0 ? ref : [];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.cancelAndReturns.description', {
        parseHTML: true
    })), hasLabel(customerServiceKey) ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "user",
        url: url
    }, text)) : null, email ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "mail",
        url: `mailto:${email}`
    }, email)) : null, phone ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "phone-with-cord",
        url: `tel:${phone}`
    }, phone)) : null);
};
var CancelAndReturnsModalContent$1 = CancelAndReturnsModalContent;

export { CancelAndReturnsModalContent$1 as default };
//# sourceMappingURL=CancelAndReturnsModalContent.js.map
